// extracted by mini-css-extract-plugin
export var component = "SearchTeaser-module--component--x+jwt";
export var title = "SearchTeaser-module--title--30iVC";
export var teaserHeader = "SearchTeaser-module--teaserHeader--pnijz";
export var hasImage = "SearchTeaser-module--hasImage--5wGbL";
export var content = "SearchTeaser-module--content--jZOMT";
export var excerpt = "SearchTeaser-module--excerpt--ymiTI";
export var meta = "SearchTeaser-module--meta--GbvSc";
export var image = "SearchTeaser-module--image--aM7XA";